import type {ReactElement} from 'react';
import React, {useEffect, useRef} from 'react';
import type {ColorStorage} from '@Components/color-picker-v2';
import {ColorFillPropertyType} from '@Components/color-fill';
import {SwatchesSection} from '@Components/color-picker-mobile/components/swatches-section';
import {PickerSection} from '@Components/color-picker-mobile/components/picker-section';

interface ColorPickerMobileProps {
  className?: string;
  color: ColorStorage[];
  onMyDesign: string[];
  type?: ColorFillPropertyType;
  isAlphaDisabled?: boolean;

  onChangeColor(color: ColorStorage[]): void;

  onChangeEnded(color: ColorStorage[]): void;

  onToggleSection(newSection: ColorPickerMobileSection): void;

  onContentChanged?(newSection: ColorPickerMobileSection): void;

  section: ColorPickerMobileSection;
  selectedIndex?: number;

  onChangeSelectedIndex(index: number): void;

  onOpenPickingMode(): void;

  onAddBrandAssetClicked?(): void;
}

export enum ColorPickerMobileSection {
  SWATCHES = 'SWATCHES',
  HEXPICKER = 'HEXPICKER',
  PICKING_MODE = 'PICKING_MODE',
}

export function ColorPickerMobile({
  isAlphaDisabled = false,
  selectedIndex = 0,
  onAddBrandAssetClicked = (): void => {},
  onContentChanged = (): void => {},
  type = ColorFillPropertyType.SOLID,
  ...props
}: ColorPickerMobileProps): ReactElement {
  const isFistRender = useRef(true);

  useEffect((): void => {
    if (isFistRender.current) {
      setTimeout((): void => {
        onContentChanged(props.section);
        isFistRender.current = false;
      }, 200);
    } else {
      onContentChanged(props.section);
    }
  }, [props.section]);

  const getSwatchesSection = (): ReactElement => {
    return (
      <SwatchesSection
        color={props.color}
        selectedIndex={selectedIndex}
        onMyDesign={props.onMyDesign}
        onToggleSection={(newSection): void => {
          props.onToggleSection(newSection);
        }}
        onChangeColor={(color): void => {
          props.onChangeColor(color);
        }}
        onChangeEnded={(color): void => {
          props.onChangeEnded(color);
        }}
        onAddBrandAssetClicked={(): void => {
          if (onAddBrandAssetClicked) {
            onAddBrandAssetClicked();
          }
        }}
      />
    );
  };

  const getHexPicker = (): ReactElement => {
    return (
      <PickerSection
        type={type}
        color={props.color}
        selectedIndex={selectedIndex}
        onChangeColor={(color): void => {
          props.onChangeColor(color);
        }}
        onChangeEnded={(color): void => {
          props.onChangeEnded(color);
        }}
        onChangeSelectedIndex={(index): void => {
          props.onChangeSelectedIndex(index);
        }}
        isAlphaDisabled={isAlphaDisabled}
      />
    );
  };

  const getContent = (): ReactElement => {
    switch (props.section) {
      case ColorPickerMobileSection.HEXPICKER:
        return getHexPicker();
      case ColorPickerMobileSection.PICKING_MODE:
        return <div>todo</div>;
      case ColorPickerMobileSection.SWATCHES:
      default:
        return getSwatchesSection();
    }
  };

  return getContent();
}
